import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";
import QuickLinks from "./UI/QuickLinks";
import SocialNavbar from "./UI/SocialNavbar";

function Footer() {
  const iconStyle = {
    marginRight: "0.5rem",
    color: "white",
    textDecoration: "none",
  };
  const navigate = useNavigate();

  return (
    <>
      <div className="footer">
        <div className="footer-upper">
          <div className="footer-column">
            <h6 className="divider-full-width">अध्यक्ष का संदेश</h6>
            <div style={{ padding: "0 1rem 1rem 1rem" }}>
              <p className="tabbed-paragraph">
                प्रिय निवासियों, हम सभी जानते हैं कि पानी जीवन का आधार है। इसके
                बिना न तो प्रकृति ...
              </p>
            </div>
            <div style={{ textAlign: "right" }}>
              <button
                className="readMoreButton"
                onClick={() => {
                  navigate("/about-us");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                Read More ...
              </button>
            </div>
          </div>
          <div className="footer-column">
            <h6 className="divider-full-width">Quick Links</h6>
            {/* <CollegeLocation /> */}
            <QuickLinks />
            {/* <SocialNavbar
              facebookURL={"https://www.facebook.com/"}
              twitterUrl={"https://x.com/"}
              instagramUrl={"https://www.instagram.com"}
              youtubeUrl={"https://youtube.com/"}
              telegramUrl={"https://telegram.org/"}
              whatsappUrl={"https://web.whatsapp.com/"}
            /> */}
          </div>
          <div className="footer-column">
            <h6 className="divider-full-width">Contact Us</h6>
            <p className="no-margin">
              <span>
                टैंकर डिलीवरी संबंधी किसी भी समस्या के लिए शानवी कार्यालय से
                संपर्क करें।:
                <br />
                {"\uD83D\uDCF1"}Mr. Kuldeep 63788 51998
                <br />
                {"\uD83D\uDCF1"}Mr. Mukesh 84324 13743
                <br />
                {"\uD83D\uDCF1"}Mr. Sanjay Sharma 98708 72491
              </span>
              <br />
              <a
                style={iconStyle}
                href="mailto:ocrws.phaseone@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                ✉️ ocrws.phaseone@gmail.com
              </a>
            </p>
          </div>
        </div>
        <div className="footer-lower">
          <p className="no-margin" style={{ textAlign: "center" }}>
            Copyright © 2025 Omaxe City Residents Welfare Society Ph-1.
            All rights reserved.
          </p>
          <p className="no-margin" style={{ textAlign: "center" }}>
            <span>
              Designed &amp; Developed By:{" "}
              <a
                href="mailto:sharmakk@live.com"
                target="_blank"
                rel="noreferrer"
              >
                Krishna Infotech Pvt. Ltd.
              </a>
            </span>{" "}
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;
